// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1_fSq","label":"LabeledBox_label__1Gir0"};